export const messages = {
  en: {
    accountWithdrawalApplyShManage: {
      title: 'Withdrawal Audit Management',
      withdrawalAudit: 'Withdrawal Audit',
      search: 'Search',
      applyUserNamePlaceholder: 'Please enter applicant name',
      applyUserTelPlaceholder: 'Please enter applicant phone',
      amount: 'Withdrawal Amount',
      applyUserName: 'Applicant Name',
      applyUserTel: 'Applicant Phone',
      context: 'Application Description',
      state: 'Status',
      actions: 'Actions',
      audit: 'Audit',
      auditSuccess: 'Audit successful'
    },
    audit: {
      state: 'Audit Status',
      remark: 'Reason',
      remarkPlaceholder: 'Required, please fill in the reason',
      cancel: 'Cancel',
      submit: 'Submit',
      agreeText: 'Agree'
    }
  },
  zh: {
    accountWithdrawalApplyShManage: {
      title: '提现审核管理',
      withdrawalAudit: '提现审核',
      search: '查询',
      applyUserNamePlaceholder: '请输入申请人名称',
      applyUserTelPlaceholder: '请输入申请人电话',
      amount: '提现金额',
      applyUserName: '申请人名称',
      applyUserTel: '申请人电话',
      context: '申请说明',
      state: '状态',
      actions: '操作',
      audit: '审核',
      auditSuccess: '审核成功'
    },
    audit: {
      state: '审核状态',
      remark: '原因',
      remarkPlaceholder: '必填，请填写原因',
      cancel: '取消',
      submit: '提交',
      agreeText: '同意'
    }
  }
}